import { ScreenSpaceEventHandler, Cesium3DTileset, Viewer } from "cesium";
import { AttachablePluginInterface } from "./CesiumWrapper";
import EventEmitter, { EventEmitterInterface } from "./EventEmitter";
import ScreenSpaceEventsPlugin from "./ScreenSpaceEventsPlugin";
import TilesetPlugin, { TilesetFeature } from "./TilesetPlugin";
import AxisLinePrimitive from "components/elements/CesiumViewer/AxisLinePrimitive";

export default class FeatureRayPickerPlugin
  implements AttachablePluginInterface
{
  private _viewer: Viewer;
  private _leftClickFeatureEvent = new EventEmitter<
    TilesetFeature | Cesium3DTileset
  >();
  private _mouseMoveFeatureEvent = new EventEmitter<TilesetFeature>();
  private _leftClickEmptyEvent = new EventEmitter();
  private _mouseMoveEmptyEvent = new EventEmitter();

  get leftClickFeatureEvent(): EventEmitterInterface<
    TilesetFeature | Cesium3DTileset
  > {
    return this._leftClickFeatureEvent;
  }
  get mouseMoveFeatureEvent(): EventEmitterInterface<TilesetFeature> {
    return this._mouseMoveFeatureEvent;
  }
  get leftClickEmptyEvent(): EventEmitterInterface {
    return this._leftClickEmptyEvent;
  }
  get mouseMoveEmptyEvent(): EventEmitterInterface {
    return this._mouseMoveEmptyEvent;
  }

  constructor(sse: ScreenSpaceEventsPlugin) {
    this.attachLeftClickPickHandler(sse.leftClickEvent);
    this.attachMouseMovePickHandler(sse.mouseMoveEvent);
  }

  setViewer(viewer: Viewer) {
    this._viewer = viewer;
  }

  detachViewer() {
    this._viewer = null;
  }

  private attachLeftClickPickHandler(
    clickEvent: EventEmitterInterface<ScreenSpaceEventHandler.PositionedEvent>,
  ) {
    clickEvent.addHandler((target) => {
      if (
        !this._viewer ||
        (!this._leftClickFeatureEvent.hasHandlers &&
          !this._leftClickEmptyEvent.hasHandlers)
      ) {
        return;
      }

      const picks = this._viewer.scene.drillPick(target.position, 1);
      const feature = picks[0];
      const tileset = feature?.["primitive"] ?? null;

      if (TilesetPlugin.isFeature(feature)) {
        this._leftClickFeatureEvent.emit(feature);
      } else if (tileset instanceof Cesium3DTileset) {
        this._leftClickFeatureEvent.emit(tileset);
      } else if (feature?.primitive instanceof AxisLinePrimitive) {
        // Don't emit empty event if we picked a transform editor axis
        // Let the transform editor handlers process it
        return;
      } else {
        this._leftClickEmptyEvent.emit();
      }
    });
  }

  private attachMouseMovePickHandler(
    moveEvent: EventEmitterInterface<ScreenSpaceEventHandler.MotionEvent>,
  ) {
    moveEvent.addHandler((movement) => {
      if (
        !this._viewer ||
        (!this._mouseMoveFeatureEvent.hasHandlers &&
          !this._mouseMoveEmptyEvent.hasHandlers)
      )
        return;
      const feature = this._viewer.scene.pick(movement.endPosition);
      if (TilesetPlugin.isFeature(feature))
        this._mouseMoveFeatureEvent.emit(feature);
      else this._mouseMoveEmptyEvent.emit();
    });
  }
}
